// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610060636/js/" + chunkId + "." + {"44":"7d4704d5","225":"3eb10983","481":"d2f9c6d7","486":"fd031954","770":"68d97a4a"}[chunkId] + ".0.9718512361002047.chunk.js";
};